const TONES = {
  slate: 'badge-neutral',
  neutral: 'badge-neutral',
  green: 'badge-success',
  red: 'badge-danger',
  amber: 'badge-warning',
  brand: 'badge-brand',
  blue: 'badge-info',
};

export default function Badge({ children, tone = 'slate', dot = false }) {
  return (
    <span className={TONES[tone] || TONES.slate}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />}
      {children}
    </span>
  );
}

/** Maps enum values from the API onto a consistent tone + human label. */
const STATUS_MAP = {
  ACTIVE: ['green', 'Active'],
  INACTIVE: ['slate', 'Inactive'],
  BOOKED: ['brand', 'Booked'],
  IN_PROGRESS: ['amber', 'In Progress'],
  IN_PRODUCTION: ['amber', 'In Production'],
  COMPLETED: ['green', 'Completed'],
  DELIVERED: ['green', 'Delivered'],
  CANCELLED: ['red', 'Cancelled'],
  CGST_SGST: ['brand', 'CGST+SGST'],
  IGST: ['blue', 'IGST'],
  // Work assignments + settlements
  ASSIGNED: ['blue', 'Assigned'],
  POSTED: ['green', 'Posted'],
  REVERSED: ['red', 'Reversed'],
  RELEASED: ['amber', 'Released'],
  SETTLED: ['brand', 'Settled'],
};

export function StatusBadge({ status }) {
  if (!status) return <span className="text-content-subtle">—</span>;
  const [tone, label] = STATUS_MAP[status] || ['slate', String(status).replace(/_/g, ' ')];
  return <Badge tone={tone} dot>{label}</Badge>;
}
